import React from 'react';
import { Link } from 'react-router';
import { Meta } from 'common/components/meta';
import { getCanonicalURL } from 'common/utils';


const TEAM = [{
  image: 'https://s3.amazonaws.com/crowdspring3-assets/marketing/crowdspring_marketing_team_ross.jpg',
  name: 'Ross Kimbarovsky',
  role: 'Founder & CEO',
  bio: 'Ross emigrated to the United States from Kiev, Ukraine in 1979. Following a 13 year career as a successful trial attorney, Ross founded (in 2007) and leads crowdspring. Ross mentors entrepreneurs through TechStars and Founder Institute, is a member of the Executive Advisory Board for TechWeek, and was honored as one of Techweek100′s top technology leaders and business visionaries. Ross has also founded numerous other startups, including Startup Foundry, Quickly Legal, and Respect. Ross wears shorts and sandals to work (on most days).',
  twitter: "https://twitter.com/rosskimbarovsky/",
  linkedin: "https://www.linkedin.com/in/rosskimbarovsky/",
},
{
  image: 'https://s3.amazonaws.com/crowdspring3-assets/marketing/crowdspring_marketing_team_jason.jpg',
  name: 'Jason Byer',
  role: 'Marketing and Business Development',
  bio: 'Jason is the oldest of 7 children. He was raised and attended school in Florida but realized he needed to feel a change of seasons, so he moved to Chicago. He\'s equally comfortable reading The Game of Thrones and Dostoyevsky, while training for triathlons and endurance races, and brewing beer. He authored Get the Job: How to Use Personal Branding to Jump-Start a Career and Dominate the Competition (and showed he knows what he\'s talking about by using this strategies to get the job at crowdspring!)',
},
{
  image: 'https://s3.amazonaws.com/crowdspring3-assets/marketing/crowdspring_marketing_team_nathan.jpg',
  name: 'Nathan Ozelim',
  role: 'Full Stack Engineer',
  bio: 'Nathan earned his degree in Computer Engineering at Universidade Federal de Sao Carlos - Brazil. In addition to his full stack role at crowdspring, Nathan likes to play outdoor sports (especially running and biking). One day, Nathan hopes to stay in a retreat at a buddhist monastery. Nathan loves music and loves reading books on topics ranging from classic novels to stock market investments. If stranded on a desert island, Nathan would just bring a time machine (which we think is cheating).',
},
{
  image: 'https://s3.amazonaws.com/crowdspring3-assets/marketing/crowdspring_marketing_team_bryson.jpg',
  name: 'Bryson Holland',
  role: 'Backend Engineer',
  bio: 'Bryson was born and raised in Las Vegas, Nevada, where for the last 12 years he has put his programming skills to work in candy, advertising, nightlife, manufacturing, and gaming. He was also a Sergeant in the US Marine Corps (0331), serving for 8 years. Bryson is an aspiring world traveler and has so far traveled Mexico, Canada, Iraq, Ireland thrice, Switzerland, France twice, and Italy. When he\'s not globe-trotting, he spends as much time as possible camping in the mountains outside of Vegas or driving his Jeep in the dirt. Bryson has also almost finished Netflix.',
},
{
  image: 'https://s3.amazonaws.com/crowdspring3-assets/marketing/crowdspring_marketing_support_katie.jpg',
  name: 'Katie Lundin',
  role: 'Marketing and Branding Specialist',
  bio: 'Katie hails from Baltimore, MD where she had many adventures before relocating to Austin, Texas (by way of Madison and Milwaukee, Wisconsin). Katie completed her masters degree at the University of Wisconsin-Madison. She never attended a single Badgers game. Katie is a problem-solver, writer, former professor and reluctant video game enthusiast. After deciding to leave academia behind, Katie now focuses her efforts on small business marketing and branding, design and copywriting.',
},
{
  image: 'https://s3.amazonaws.com/crowdspring3-assets/marketing/crowdspring_marketing_support_marc.png',
  name: 'Marc Boyle',
  role: 'Customer Support Manager',
  bio: 'Marc is a New Jersey native, exit 114, who traversed down to Florida to be closer to his family. With almost 10 years of service related experience, his can-do attitude can help make any mountain feel conquerable. He\'s also known for playing basement rock shows, working with video game development, creating websites, and setting up turntables. Make sure to refrain from talking about music, cars, or food unless you are ready for an in depth conversation!',
},
{
  image: 'https://s3.amazonaws.com/crowdspring3-assets/marketing/crowdspring_marketing_support_jordan.png',
  name: 'Jordan King',
  role: 'Customer Support Superhero',
  bio: 'Jordan was born and raised in a small town in Maine, where he inevitably gained his love for all things New England sports. When he\'s not catching a game, you can find him refusing to grow up with his addiction to marshmallow cereal and affinity for toy stores. He\'s also on a mission to bring back the 90\'s and has a nostalgia for mullets and windbreakers. Jordan has been hard at work for the past 10 years doing technical support and is finishing up his Bachelor\'s degree in Mental Health. He loves helping others and lending a hand.....except on Sunday\'s, which are for Game of Thrones.',
},
{
  image: 'https://s3.amazonaws.com/crowdspring3-assets/marketing/crowdspring_marketing_support_stefanie.jpg',
  name: 'Stefanie Wittmaak',
  role: 'Customer Support Superhero',
  bio: 'Originally from Pennsylvania, Stefanie now resides in the \'Sunshine City\' St. Petersburg, Florida. When she’s not slathering on SPF, Stefanie enjoys homemade chai tea lattes, dreaming about winning the lottery (but never actually playing), and looking forward to the next Marvel movie. Stefanie is also a photographer and utilizes her two kiddos as free models whenever possible. In the future, Stefanie hopes to someday again sleep a solid eight hours.',
},
{
  image: 'https://s3.amazonaws.com/crowdspring3-assets/marketing/crowdspring_marketing_support_ashlee.jpg',
  name: 'Ashlee Brayfield',
  role: 'Customer Support Superhero',
  bio: ' Ashlee grew up in the frozen tundra known as Michigan, and because she only operates in extremes, now resides with her family in the tropical (read: hot!) state of Florida. When not busy raising three tiny humans, Ashlee enjoys playing with her dog Eleanor "Ellie" Rigby, writing, and video games. Her favorite movie and novella are Shopgirl, and she would consider committing a litany of crimes to share a meal with Steve Martin. Ashlee has been an Autism Advocate since 2012 when her son Liam was diagnosed and can credit him to her endless supply of dad jokes.'
},
];

const Team = () => (
  <div className="team">
    <Meta
      title="Team"
      meta={[
        { name: 'robots', content: 'index,follow' },
        { name: 'description', content: 'The crew at crowdspring' },
        { name: 'keywords', content: 'crowdsource, contests, design contests, writing contests, copywriting, design, crowdsourcing' },
        { property: 'og:title', content: 'crowdspring team' },
        { property: 'og:description', content: 'The crew at crowdspring' },
        { property: 'og:url', content: getCanonicalURL('/about-us/team/') },
      ]}
      link={[{ rel: 'canonical', href: getCanonicalURL('/about-us/team/') }]}
    />
    <div className="row">
      <div className="columns small-16">
        <h2 className="hide-for-medium">Meet our Crew</h2>
      </div>
    </div>

    {TEAM.map((member, i) => (
      <section className="team-member" key={i}>
        <div className="row">
          <div className="columns small-16 large-2">
            <img
              src={member.image}
              className="avatar avatar-lg avatar-round avatar-team no-border"
              alt={member.name}
            />
          </div>
          <div className="columns small-16 large-10 team-blurb">
            <h3 className="team-member-name">{member.name}</h3>
            <h4 className="team-member-position">{member.role}</h4>
            <p className="team-member-bio">{member.bio}</p>
          </div>
        </div>
        <div className="row">
          <div className="columns large-offset-2 small-16 large-10 team-social-media">
            <ul>
              { member.twitter &&
              <li>
                <a href={member.twitter} target="_blank" className="btn btn-with-icon">
                  <i className="fa fa-twitter" /> Follow {member.name.split(' ')[0]} on Twitter
                </a>
              </li> }
              { member.linkedin &&
              <li>
                <a href={member.linkedin} target="_blank" className="btn btn-with-icon">
                  <i className="fa fa-linkedin" /> Connect on LinkedIn
                </a>
              </li> }
            </ul>
          </div>
        </div>
      </section>
    ))}
  </div>
);

export default Team;



// WEBPACK FOOTER //
// ./marketing/about/team.jsx